/*** IMPORTS FROM imports-loader ***/
var shim = require("es5-shim/es5-shim");
var sham = require("es5-shim/es5-sham");

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var browser = require('../../helper/browser');
var config = require('../config');

var Reward = function () {
    function Reward(_ref) {
        var jsonObj = _ref.jsonObj,
            Room = _ref.Room;
        (0, _classCallCheck3["default"])(this, Reward);

        this.donateTimes = +jsonObj.donateTimes || 0;
        this.cash_donate_id = jsonObj.act.cash_donate_id;
        this.donate_type = jsonObj.act.donate_type;
        this.reward_config = jsonObj.act.gift_config;
        this.gifts = jsonObj.act.gifts || [];
        this.cash_config = { id: this.cash_donate_id };
        this.cash_record_list = [];
        this.act_id = jsonObj.act.id;
        this.freeGiftLock = false;

        this.Room = Room;

        this.isSetType = [];
        jsonObj.issetNetbank && this.isSetType.push('netbank');
        jsonObj.issetAlipay && this.isSetType.push('alipay');
        jsonObj.issetWeixinPay && this.isSetType.push('weixin');

        this._getCashConfig();
        this._ropOnCashDonateMessage();
        this._ropOnGiftDonateMessage();
        this._ropOnGiftSend();
        this._msgbusDestroy();
    }

    (0, _createClass3["default"])(Reward, [{
        key: '_msgbusDestroy',
        value: function _msgbusDestroy() {
            var _this = this;

            this.destroyKey = _scope.MsgBus.On('Destroy', function () {
                _scope.MsgBus.UnSubAll('Reward.CashConfig.Changed');
                _scope.MsgBus.UnSubAll('Reward.CashRecord.Changed');

                rop.Remove('cash_donate_' + _this.cash_donate_id);
                _scope.MsgBus.UnSubAll('Reward.CashPay.Result');

                rop.Remove('cash_PropPay_' + _this.act_id);
                _scope.MsgBus.UnSubAll('Reward.GiftPay.Result');

                _this.gifts.map(function (v) {
                    rop.Remove('act_gift_send_' + v.id);
                });
                _scope.MsgBus.UnSubAll('Reward.Gift.Sended');
                _scope.MsgBus.UnSubAll('Reward.GiftFree.Result');

                _scope.MsgBus.UnSub(_this.destroyKey);
            });
        }
    }, {
        key: '_objToArray',
        value: function _objToArray(obj) {
            var ret = [];
            if (!obj) {
                return ret;
            }
            for (var key in obj) {
                ret.push(obj[key]);
            }
            return ret;
        }
    }, {
        key: '_getCashConfig',
        value: function _getCashConfig() {
            var _this2 = this;

            if (this.cash_donate_id) {
                var data = { donateId: this.cash_donate_id };
                Fetcher.PostForm(config.CASH_DONATE_DETAIL_URL, data, function (res) {
                    res = JSON.parse(res);
                    _this2.cash_config.accounce_image = res.accounce_image;
                    _this2.cash_config.accounce_word = res.accounce_word;
                    _this2.cash_config.lowest = res.lowest;
                    _this2.cash_config.showAmount = res.showAmount;
                    _this2.cash_config.totalSum = res.totalSum;
                    _this2.cash_config.userNum = res.userNum;
                    _this2.cash_record_list = _this2._objToArray(res.detail);

                    _scope.MsgBus.Pub('Reward.CashConfig.Changed', JSON.parse((0, _stringify2["default"])(_this2.cash_config)));
                    _scope.MsgBus.Pub('Reward.CashRecord.Changed', JSON.parse((0, _stringify2["default"])(_this2.cash_record_list)));
                });
            }
        }
    }, {
        key: '_ropOnCashDonateMessage',
        value: function _ropOnCashDonateMessage() {
            var _this3 = this;

            if (this.cash_donate_id) {
                rop.On('cash_donate_' + this.cash_donate_id, function (data) {
                    data = JSON.parse(data);

                    if (data.tradeId && data.visitorId == _scope.DB.Get('UserInfo').id) {
                        _scope.MsgBus.Pub('Reward.CashPay.Result', { status: 'y', flag: 100, info: '支付成功' });
                    }

                    _this3._getCashConfig();
                });
            }
        }
    }, {
        key: '_ropOnGiftDonateMessage',
        value: function _ropOnGiftDonateMessage() {
            // 用户礼物打赏成功或失败
            rop.On('cash_PropPay_' + this.act_id, function (data) {
                data = JSON.parse(data);

                // tradeId存在才是付费打赏，否则是免费打赏
                if (data.tradeId && data.visitorId == _scope.DB.Get('UserInfo').id) {
                    _scope.MsgBus.Pub('Reward.GiftPay.Result', { status: 'y', flag: 100, info: '支付成功' });
                }
            });
        }
    }, {
        key: '_ropOnGiftSend',
        value: function _ropOnGiftSend() {
            var _this4 = this;

            this.gifts.map(function (v, i) {
                // 监听是否有人送礼物
                rop.On('act_gift_send_' + v.id, function (data) {
                    data = JSON.parse(data);

                    // 打赏次数+1
                    _this4.donateTimes++;
                    _this4.gifts[i].recv_times++;
                    _this4.gifts[i].recv_num = +_this4.gifts[i].recv_num + +data.num;

                    _scope.MsgBus.Pub('Reward.Gift.Sended', { gift_id: v.id, num: +data.num });
                });
            });
        }
    }, {
        key: '_getCashDonateUrl',
        value: function _getCashDonateUrl(obj) {
            // var userInfo = _scope.DB.Get('UserInfo');
            // var user = userInfo.user;
            // var avatar = userInfo.avatar;
            // var visitorId = userInfo.id;
            var url = this.Room.domain + config.RELATIVE_DONATE_URL + '&channel=' + obj.payType + '&donate_id=' + obj.donate_id + '&donate_num=' + obj.donate_num + '&act_id=' + this.act_id + ('&t=' + new Date().getTime());

            obj.payType == 'weixin' && !browser.isMobile() && (url += '&payType=native');

            url += '&phone=' + (obj.phone || '');
            return url;
        }
    }, {
        key: '_getGiftDonateUrl',
        value: function _getGiftDonateUrl(obj) {
            // var userInfo = _scope.DB.Get('UserInfo');
            // var user = userInfo.user;
            // var avatar = userInfo.avatar;
            // var visitorId = userInfo.id;
            var url = this.Room.domain + config.RELATIVE_DONATE_URL + '&channel=' + obj.payType + '&gift_id=' + obj.gift_id + '&num=' + obj.num + '&act_id=' + this.act_id + ('&t=' + new Date().getTime() + '&referer=' + encodeURIComponent(window.location.href));

            obj.payType == 'weixin' && !browser.isMobile() && (url += '&payType=native');

            url += '&phone=' + (obj.phone || '');

            return url;
        }

        // 根据不同的url和paytype做不同的处理：调用原生支付、跳转支付等等

    }, {
        key: '_resolvePayUrl',
        value: function _resolvePayUrl(url, payType, evt) {
            // console.log(url, payType, evt);
            if (!browser.isMobile()) {
                // pc端

                if (payType == 'weixin') {
                    // 微信扫码支付，不做处理
                } else {
                    // 支付宝、银联链接跳转支付
                    window.open(url);
                }
            } else {
                // 移动端

                if (payType == 'weixin' && browser.isWechat()) {
                    // 微信原生支付
                    if (!_scope.Utils.GetCookie('openId')) {
                        _scope.MsgBus.Pub(evt, { status: 'n', flag: 101, info: '微信支付找不到openId, 请先进行微信登录或者使用扫码支付替代', data: { url: url + '&payType=native' } });
                    } else {
                        this._resolveWeixinPay(url, evt);
                    }
                }

                if (payType == 'alipay') {
                    if (browser.isDingding()) {
                        // 钉钉支付宝原生支付
                        this._resolveDingdingAlipay(url, evt);
                    } else {
                        // 非钉钉的支付宝支付: 链接跳转
                        window.open(url);
                    }
                }
            }

            return url;
        }
    }, {
        key: '_resolveDingdingAlipay',
        value: function _resolveDingdingAlipay(url, evt) {
            Fetcher.Get(url + '&payType=native&type=mobile', function (res) {
                dd.biz.alipay.pay({
                    data: res,
                    onSuccess: function onSuccess() {
                        _scope.MsgBus.Pub(evt, { status: 'y', flag: 100, info: '支付成功' });
                    },
                    onFail: function onFail(err) {
                        _scope.MsgBus.Pub(evt, { status: 'n', flag: 103, info: '钉钉支付宝原生支付失败', data: { error: err } });
                    }
                });
            });
        }
    }, {
        key: '_resolveWeixinPay',
        value: function _resolveWeixinPay(url, evt) {
            var _this5 = this;

            Fetcher.Get(url, function (res) {
                res = JSON.parse(res);
                if (typeof WeixinJSBridge == 'undefined') {
                    var cb = function cb() {
                        return _this5._resolveWeixinPaySdk(res, url, evt);
                    };
                    if (document.addEventListener) {
                        document.addEventListener('WeixinJSBridgeReady', cb, false);
                    } else {
                        document.attachEvent('WeixinJSBridgeReady', cb);
                        document.attachEvent('onWeixinJSBridgeReady', cb);
                    }
                } else {
                    _this5._resolveWeixinPaySdk(res, url, evt);
                }
            });
        }
    }, {
        key: '_resolveWeixinPaySdk',
        value: function _resolveWeixinPaySdk(weixinConfigJson, url, evt) {
            WeixinJSBridge.invoke('getBrandWCPayRequest', (0, _extends3["default"])({}, weixinConfigJson, { timeStamp: weixinConfigJson.timeStamp + '' }), function (res) {
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    _scope.MsgBus.Pub(evt, { status: 'y', flag: 100, info: '支付成功' });
                } else {
                    _scope.MsgBus.Pub(evt, { status: 'n', flag: 102, info: '微信支付失败，您可以使用二维码进行微信支付', data: { url: url, error: res } });
                }
            });
        }
    }, {
        key: '_findGiftById',
        value: function _findGiftById(gift_id) {
            var ret = null;
            this.gifts.map(function (v) {
                if (v.id == gift_id) {
                    ret = v;
                }
            });
            return ret;
        }

        /**
         * 停止监听ws消息
         */

    }, {
        key: 'UnSubRewardTopics',
        value: function UnSubRewardTopics() {
            rop.Remove('cash_PropPay_' + this.act_id);
            rop.Remove('cash_donate_' + this.cash_donate_id);
        }
    }, {
        key: 'GetAvailablePayTypes',
        value: function GetAvailablePayTypes() {
            if (browser.isMobileWechat()) {
                // 手机微信
                if (this.isSetType.indexOf('weixin')) {
                    return ['weixin'];
                } else {
                    return [];
                }
            }

            if (browser.isMobile()) {
                // 手机其他浏览器
                if (this.isSetType.indexOf('alipay')) {
                    return ['alipay'];
                } else {
                    return [];
                }
            }

            if (browser.isWechat()) {
                // pc微信
                if (this.isSetType.indexOf('weixin')) {
                    return ['weixin'];
                } else {
                    return [];
                }
            }

            // pc其他浏览器
            return this.isSetType;
        }
    }, {
        key: 'GetRewardType',
        value: function GetRewardType() {
            return this.donate_type;
        }
    }, {
        key: 'GetRewardConfig',
        value: function GetRewardConfig() {
            return this.reward_config;
        }
    }, {
        key: 'GetCashConfig',
        value: function GetCashConfig() {
            return this.cash_config;
        }
    }, {
        key: 'GetGiftConfig',
        value: function GetGiftConfig() {
            return { gifts: this.gifts };
        }
    }, {
        key: 'GetCashRecords',
        value: function GetCashRecords() {
            return this.cash_record_list;
        }
    }, {
        key: 'GetGiftRankList',
        value: function GetGiftRankList(gift_id, cb) {
            if (!+gift_id) {
                return;
            }
            var url = config.GIFT_DETAIL_URL + '&num=50&gift_id=' + gift_id;
            Fetcher.Get(url, function (res) {
                res = JSON.parse(res);
                cb(res.data);
            });
        }
    }, {
        key: 'CashReward',
        value: function CashReward(obj) {
            obj = obj || {};
            var num = +obj.num || 0;
            var payType = obj.payType;
            var phone = obj.phone;
            var donate_id = obj.donate_id || this.cash_donate_id;
            var num_limit = +this.cash_config.lowest || 0.01;

            if (this.donate_type == 1) {
                return { status: 'n', flag: 101, info: '当前打赏配置为道具打赏' };
            }
            if (this.GetAvailablePayTypes().indexOf(payType) < 0) {
                return { status: 'n', flag: 103, info: '当前支付方式不可用' };
            }
            if (num < num_limit) {
                return { status: 'n', flag: 102, info: '\u6253\u8D4F\u91D1\u989D\u4E0D\u80FD\u5C0F\u4E8E' + num_limit };
            }
            var url = this._getCashDonateUrl({ payType: payType, donate_id: donate_id, donate_num: num, phone: phone });

            this._resolvePayUrl(url, payType, 'Reward.CashPay.Result');

            if (payType == 'weixin' && !browser.isMobile()) {
                return { status: 'y', flag: 100, info: '微信打赏中，请显示图片', data: { url: url, eventKey: 'Reward.CashPay.Result' } };
            }

            return { status: 'y', flag: 100, info: '支付中，请等待结果', data: { eventKey: 'Reward.CashPay.Result' } };
        }
    }, {
        key: 'GiftReward',
        value: function GiftReward(obj) {
            var _this6 = this;

            obj = obj || {};
            var gift_id = +obj.gift_id || 0;
            var payType = obj.payType;
            var phone = obj.phone || '';
            var num = Math.round(obj.num) || 1;
            var gift = this._findGiftById(gift_id);

            if (this.donate_type == 2) {
                return { status: 'n', flag: 101, info: '当前打赏配置为现金打赏' };
            }

            if (!gift_id) {
                return { status: 'n', flag: 102, info: 'gift_id不能为空' };
            }

            if (!gift) {
                return { status: 'n', flag: 104, info: '\u627E\u4E0D\u5230gift_id\u4E3A' + gift_id + '\u7684\u9053\u5177' };
            }

            if (this.GetAvailablePayTypes().indexOf(payType) < 0 && +gift.price > 0) {
                return { status: 'n', flag: 103, info: '当前支付方式不可用' };
            }

            if (+gift.price == 0) {
                if (this.freeGiftLock) {
                    return { status: 'n', flag: 105, info: '免费打赏频率过高' };
                }

                this.freeGiftLock = true;
                // 免费打赏有3s的间隔，防止刷礼物
                setTimeout(function () {
                    return _this6.freeGiftLock = false;
                }, 3000);

                this._freeGiftReward({ num: num, gift_id: gift_id, phone: phone });
                return { status: 'y', flag: 100, info: '免费打赏中', data: { eventKey: 'Reward.GiftFree.Result' } };
            }

            var url = this._getGiftDonateUrl({ payType: payType, gift_id: gift_id, phone: phone, num: num });

            this._resolvePayUrl(url, payType, 'Reward.GiftPay.Result');

            if (payType == 'weixin' && !browser.isMobile()) {
                return { status: 'y', flag: 100, info: '微信打赏中，请显示图片', data: { url: url, eventKey: 'Reward.GiftPay.Result' } };
            }

            return { status: 'y', flag: 100, info: '支付中，请等待结果', data: { eventKey: 'Reward.GiftPay.Result' } };
        }
    }, {
        key: '_freeGiftReward',
        value: function _freeGiftReward(obj) {
            var data = {
                act_id: this.act_id,
                num: obj.num,
                gift_id: obj.gift_id,
                name: _scope.Utils.GetCookie('user'),
                avatar: _scope.Utils.GetCookie('avatar'),
                phone: obj.phone
            };
            Fetcher.PostForm(config.FREE_GIFT_DONATE_URL, data, function (res) {
                res = JSON.parse(res);
                _scope.MsgBus.Pub('Reward.GiftFree.Result', (0, _stringify2["default"])({ status: res.status, flag: res.flag, info: res.msg }));
            });
        }
    }]);
    return Reward;
}();

module.exports = Reward;



/*****************
 ** WEBPACK FOOTER
 ** ./~/es3ify-loader!./~/imports-loader?shim=es5-shim/es5-shim&sham=es5-shim/es5-sham!./~/babel-loader/lib!./application/components/core/Reward.js
 ** module id = 185
 ** module chunks = 1
 **/